<div class="filter-panel" [class.open]="isOpen">
  <div class="filter-inner">
    <div class="filter-search">
      <span class="material-icons">search</span>
      <input #searchInput class="input-search" type="text" placeholder="Search" (input)="onSearch(($any($event.target).value))" />
    </div>

    <div class="filter-group" [hidden]="tags.length === 0">
      <div class="filter-label">{{setHighlightsText()}}</div>
      <div class="filter-chips">
        @for (tag of tags; track tag) {
          <button
            type="button"
            class="filter-chip-btn"
            [class.active]="isTagActive(tag)"
            (click)="tagClicked.emit(tag)">
            {{ tag }}
          </button>
        }
      </div>
    </div>

    @if(isRoomOfferType()) {
      <div class="filter-group" [hidden]="bedTypes.length === 0">
        <div class="filter-label">Bed and room type</div>
        <div class="filter-chips">
          @for (bedType of bedTypes; track bedType) {
            <button
              type="button"
              class="filter-chip-btn"
              [class.active]="isBedTypeActive(bedType)"
              (click)="bedTypeClicked.emit(bedType)">
              {{ getBedTypeDisplayName(bedType) }}
            </button>
          }
        </div>
      </div>
    }
    <div class="filter-group" [hidden]="!hasFeaturedOffers && !hasFavoriteOffers && !favoriteOnly">
      <div class="filter-label">Featured</div>
      <div class="filter-chips">
        <button
          type="button"
          class="filter-chip-btn"
          [class.active]="featuredOnly"
          (click)="featuredClicked.emit()">
          Featured
        </button>

        <button
          type="button"
          class="filter-chip-btn"
          [class.active]="favoriteOnly"
          (click)="favoriteClicked.emit()">
          Favorites
        </button>
      </div>
    </div>



  </div>
</div>
